import React, { Component, Fragment } from 'react';
import { Image } from 'react-bootstrap';
import { Button, Col, Container, Row, UncontrolledAlert } from 'reactstrap';
import cubeApiClient from '../BusinessObjects/cubeApiService';
import LoggedContext from '../BusinessObjects/LoggedContext';
import EsaedroResourceAttachment from '../Models/EsaedroResourceAttachment';
import { themeBackButton } from '../Utils/EsaedroTheme';
import EsaedroAttachment from './EsaedroAttachment';

/************** COMPONENTE PER AGGIUNGERE ALLEGATI AD UNA RISORSA ********************************************************************/
/************** Gestisce l'upload di uno o più allegati in memoria e infine li invia al CUBE, che li assegna ad una risorsa **********/

interface IEsaedroAttachmentLoaderProps {
    Resource_ID: number,
    Item_ID: number,
    onReturn?(ackMessage?: string): void
}

interface IEsaedroAttachmentLoaderState {
      uploading: boolean,
      successMessage: string,
      errorMessage: string,
      attachments: EsaedroResourceAttachment[],
}

function Buttons (props: any) {
  return (
    <div className='buttons fadein'>
      <div className='button'>
        <label htmlFor='multi'>
          <i className="fa fa-upload"> </i>
        </label>
        <input type='file' id='multi' onChange={props.onChange} multiple />
      </div>
    </div>
  )
}

export default class EsaedroAttachmentLoader extends Component<IEsaedroAttachmentLoaderProps, IEsaedroAttachmentLoaderState> {

  static contextType = LoggedContext
  context!: React.ContextType<typeof LoggedContext>
  attachmentsUrl: string = "api/sys/ResourcesAttachments"
  
  constructor(props: IEsaedroAttachmentLoaderProps){
    super(props);

    this.state = {
      uploading: false,
      successMessage: "",
      errorMessage: "",
      attachments: [],
    };
  }

  onChange = (event: any) => {

    this.setState({ uploading: true })

    const files = Array.from(event.target.files)

    // Creo degli oggetti di tipo EsaedroImagesController e li aggiungo all'array di allegati
    files.forEach((file: any ) => {
      this.readAndAdd(file)
    })

    this.setState({ 
        uploading: false
    })
    
  }

  readAndAdd = (file: File) => {
    var newImages = this.state.attachments
    var reader = new FileReader()

    reader.onload = () => {
      let imgUrl = reader.result
      let newFile = new EsaedroResourceAttachment(this.props.Resource_ID, this.props.Item_ID, 0, imgUrl)
      newImages.push(newFile)
      this.setState({ 
        attachments: newImages
      })
    }
    reader.readAsDataURL(file)
  }

  removeImage = (attachment: EsaedroResourceAttachment) => {
    let i = this.state.attachments.indexOf(attachment)
    // Rimuove l'elemento i-esimo dall'array
    let newImages = this.state.attachments
    newImages.splice(i,1)
    this.setState({
      attachments: newImages
    })
  }

  returnToEdit = (event: any) => {
    // Per tornare alla Edit senza inviare le immagini
    if (this.props.onReturn!=undefined) {
      this.props.onReturn()
    }
  }

  sendImages = (event: any) => {
    // Qui mando le Risorse raccolte al cube. Capire se posso mandarle tutte insieme
    // Chiama il servizio di update

    const service = new cubeApiClient();
    event.preventDefault();

    this.setState({uploading:true})

    service
      .updateObjects(this.state.attachments, this.attachmentsUrl, this.context.tokenAPI)
      .then(() => {
        this.setState({ 
          // Gestire il successo
          successMessage:' Allegati caricati con successo!',
          uploading: false
        });
        //alert("sto per tornare alla lista!")
        if (this.props.onReturn!=undefined) {
          let successMsg = "Allegati caricati con successo!"
          this.props.onReturn(successMsg)
        }
    },
    (error: any) => {
        let stringError = "Errore nel caricamento:"+JSON.stringify(error)
        this.setState({ 
          errorMessage: stringError,
          uploading: false 
        });
    });
  
  }
  
  render() {
    const { uploading, attachments } = this.state

    const successMessageAlert =  (
      (this.state.successMessage != '')?
        <UncontrolledAlert color="success">
          {this.state.successMessage}
        </UncontrolledAlert>
      : undefined
    )

    const errorMessageAlert =  (
        (this.state.errorMessage != '')?
          <UncontrolledAlert color="danger">
            {this.state.errorMessage}
          </UncontrolledAlert>
        : undefined
    )

    const content = (
      uploading? 
        <div>Caricamento...</div>
        :(attachments.length > 0)?
          attachments.map((attachment: EsaedroResourceAttachment, i: number) => 
            <Row>
              <EsaedroAttachment 
                    key={i} 
                    attachment={attachment.Content} 
                    attachmentFieldName={""} 
                    name={attachment.Description} 
                    canLoad={false} 
                    canDelete={true} 
                    resourceAttachment={attachment} 
                    onDelete={this.removeImage}>
              </EsaedroAttachment>
              &nbsp;
            </Row>  
          )
      :<span>Nessun allegato da visualizzare</span> 
    )

    const contentButtons = 
      <Fragment>
        <Row>
          <Buttons onChange={this.onChange} />
        </Row> 
        <Row>
          <Col>
            <Button 
              onClick={this.sendImages}
            >
              <i className="fa fa-upload"> </i> Carica immagini
            </Button>
          </Col>
          <Col>
            <Button 
              onClick={this.returnToEdit}
            >
              <i className="fa fa-close"> </i> Torna alla Risorsa
            </Button>
          </Col>
        </Row> 
      </Fragment>

    return (
      <Container>
        {successMessageAlert}
        <Row>
          &nbsp;
        </Row>
        {errorMessageAlert}
        <Row>
          &nbsp;
        </Row>
        {content}
        <Row>
          &nbsp;
        </Row>
        {contentButtons}
      </Container>
    )

    /*const content = () => {
      switch(true) {
        case uploading:
          return <div>Uploading...</div>
        case attachments.length > 0:
          return (
            // TODO Controllare il tipo di attachment prima di renderizzare Images
            <Fragment>
              <Images images={attachments} removeImage={this.removeImage} />
              <Buttons onChange={this.onChange} />
              <Button 
                onClick={this.sendImages}
              >
                <i className="fa fa-upload"> </i>
              </Button><Button 
                onClick={this.returnToEdit}
              >
                <i className="fa fa-close"> </i>
              </Button>
            </Fragment>
          )
        default:
          return <Buttons onChange={this.onChange} />
      }
    }

    return (
      <div>
        <div className='buttons'>
          {content()}
        </div>
      </div>
    )*/
  }
}